export enum ScannedPropertyActionType {
    Intake = 1,
    Move = 2,
    Transfer = 3,
    SignOut = 4,
    MarkForDestruction = 5,
    Destroy = 6,
    ReturnToOwner = 7
}